import { createFileRoute, Link } from "@tanstack/react-router";
import { Mail } from "lucide-react";
import { SiteLayout } from "@/components/site/SiteLayout";
import { seo } from "@/lib/seo";

export const Route = createFileRoute("/contact")({
  head: () => ({
    meta: [
      ...seo({
        title: "Contact Us | Wholesale Japanese Tea Pricing & Quotes | QT Foods",
        description:
          "Contact QT Foods for B2B pricing on bulk matcha powder, wholesale sencha, hojicha, and private label Japanese tea inquiries.",
      }),
    ],
  }),
  component: Page,
});

function Page() {
  return (
    <SiteLayout breadcrumbs={[{ label: "Contact" }]}>
      <section className="mx-auto max-w-4xl px-5 pt-10 pb-20 lg:px-8 lg:pt-14 lg:pb-28">
        <h1 className="mt-3 font-serif text-5xl md:text-6xl">Get in touch.</h1>
        <p className="mt-5 max-w-xl text-muted-foreground">
          For pricing on specific products, the fastest path is to build an inquiry list from the
          catalog. For everything else, reach us at the address below.
        </p>

        <div className="mt-12 grid gap-8 md:grid-cols-2">
          <div className="border border-border bg-card p-8">
            <Mail className="h-5 w-5 text-primary" />
            <h2 className="mt-4 font-serif text-2xl">Email</h2>
            <a
              href="mailto:sales@qtfoods.co.jp"
              className="mt-2 inline-block text-primary hover:underline"
            >
              sales@qtfoods.co.jp
            </a>
            <p className="mt-3 text-sm text-muted-foreground">
              For wholesale, private-label and general inquiries.
            </p>
          </div>
          <div className="border border-border bg-card p-8">
            <h2 className="font-serif text-2xl">Start an inquiry</h2>
            <p className="mt-2 text-sm text-muted-foreground">
              Add products to your inquiry list and send a wholesale request with quantities.
            </p>
            <Link
              to="/collections"
              className="mt-4 inline-block rounded-sm bg-primary px-5 py-2.5 text-sm font-medium tracking-wide text-primary-foreground hover:bg-primary/90"
            >
              Browse catalog
            </Link>
          </div>
        </div>
      </section>
    </SiteLayout>
  );
}
